<template>
  <div class="container">
    <Loader v-if="isLoading" />

    <div v-else class="Donation-image">
      <div class="Donation-image__title">
        <p>
          <b>Teşekkürler {{donatorName}}</b>
        </p>
      </div>
      <div class="Donation-image__desc">
        <p>{{date}} tarihinde yaptığınız {{productName}} bağışınız ile ilgili görseller aşağıdadır.</p>
      </div>

      <div class="Donation-image__images" v-if="images.length">
        <gallery :images="imagesPath" :index="index" @close="index = null"></gallery>
        <div class="Donation-wrapper">
          <div
            class="Donation-image__images--img image"
            v-for="(image, imageIndex) in images"
            :key="imageIndex"
            @click="index = imageIndex"
            :style="{ backgroundImage: 'url(' + img(image.path) + ')'}"
          ></div>
        </div>
      </div>

      <div class="Donation-image__images mt-5" v-if="videos.length">
        <div v-for="(video, idx) in videos" :key="idx">
          <video width="100%" height="100%" controls>
            <source :src="img(video.path)" type="video/mp4" />
          </video>
        </div>
      </div>

      <div class="Donation-image__share">
        <p>Sosyal Medyada Paylaş</p>
        <a :href="wpLink" data-action="share/whatsapp/share">
          <i class="fab fa-whatsapp"></i>
        </a>
        <a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=#url">
          <i class="fab fa-facebook"></i>
        </a>
        <a target="_blank" :href="twitterLink">
          <i class="fab fa-twitter"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import VueGallery from 'vue-gallery'

export default {
  data() {
    'DonationImages'

    return {
      donatorName: '',
      productName: '',
      twitterLink: '',
      date: '',
      wpLink: '',
      images: [],
      videos: [],
      imagesPath: '',
      index: null,
      isLoading: true
    }
  },

  components: {
    gallery: VueGallery
  },
  created() {
    const { id } = this.$route.params
    const { token } = this.$route.params

    this.$http.get(`receipt-detail/${id}/media?token=${token}`).then((res) => {
      this.donatorName = res.data.donator
      this.productName = res.data.donation_product
      this.date = res.data.created_at
      this.images = res.data.media.filter(image => image.type === 'image')
      this.videos = res.data.media.filter(video => video.type === 'video')
      this.imagesPath = this.images.map(img => this.img(img.path))
      this.isLoading = false
    })

    this.wpLink = `whatsapp://send?text=http://bagis.ismailagadernegi.org.tr${this.$route.fullPath}`
    this.twitterLink = `https://twitter.com/intent/tweet?text=http://bagis.ismailagadernegi.org.tr${this.$route.fullPath}`
  }
}
</script>

<style scoped>
.image {
  float: left;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
</style>
